export default "__VITE_ASSET__B257zk6i__"